import { render, staticRenderFns } from "./Encuentro.vue?vue&type=template&id=50051480&"
import script from "./Encuentro.vue?vue&type=script&lang=js&"
export * from "./Encuentro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports